import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { StatusCategory } from '@atlassian/jira-shared-types/src/rest/jira/status-category.tsx';

export const getStatusCategories = (): Promise<StatusCategory[]> =>
	fetchJson('/rest/api/3/statuscategory');
